import Node from './Node.js';

class CodeNode extends Node {
  constructor() {
    let code = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    let nodeType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'code';
    super(nodeType);
    this.code = code;
    this._includes = [];
  }

  setIncludes(includes) {
    this._includes = includes;
    return this;
  }

  getIncludes() {
    return this._includes;
  }

  generate(builder) {
    const includes = this.getIncludes(builder);

    for (const include of includes) {
      include.build(builder);
    }

    const nodeCode = builder.getCodeFromNode(this, this.getNodeType(builder));
    nodeCode.code = this.code;
    return nodeCode.code;
  }

}

CodeNode.prototype.isCodeNode = true;
export default CodeNode;